// extracted by mini-css-extract-plugin
export var boldText = "_5u-4";
export var checkboxContainer = "_5u-6";
export var closeIcon = "_5u-i";
export var container = "_5u-0";
export var drawer = "_5u-8";
export var drawerContent = "_5u-9";
export var extraSmallText = "_5u-5";
export var fulfillmentGroupTable = "_5u-e";
export var largeText = "_5u-3";
export var loadingSpinnerContainer = "_5u-j";
export var mediumText = "_5u-2";
export var narrow = "_5u-f";
export var notificationLink = "_5u-l";
export var packageCheckIconContainer = "_5u-7";
export var slideoutHeaderActions = "_5u-g";
export var slideoutHeaderActionsShifted = "_5u-h";
export var slideoutHeaderContainer = "_5u-a";
export var slideoutModal = "_5u-c";
export var stickyHeaderWrapper = "_5u-b";
export var table = "_5u-k";
export var tableContainer = "_5u-d";
export var tertiaryText = "_5u-1";